import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { DetailInfos } from '../../../components/DetailInfos'
import { KemCardDisclaimer } from '../../../components/KemCardDisclaimer'
import { useTheme } from '@/hooks/useTheme'

interface KemCardDetailsBSChildrenProps {
  onConfirm: () => void
}

export const KemCardDetailsBSChildren: React.FC<
  KemCardDetailsBSChildrenProps
> = ({ onConfirm }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <BaseView
      style={{
        // gap: '34px', //added padding to main content section
        paddingHorizontal: '12px',
        paddingTop: '32px',
        height: '92%',
        paddingBottom: '12px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Title */}
      <BaseText fontSize={24} fontFamily="semibold" color="label.default">
        {t('translation:kemCard.detailsAbout', 'Details About Kem Card')}
      </BaseText>

      {/* Scrollable Content */}
      <BaseView
        flex={1}
        style={{
          overflowY: 'auto',
          gap: '20px',
        }}
      >
        {/* Detail Information */}
        <DetailInfos />

        {/* Disclaimer */}
        <KemCardDisclaimer />
      </BaseView>

      {/* Bottom Button */}
      <BaseView
        style={{
          marginTop: 'auto',
          // paddingTop: '12px', //padding from main content details info component
        }}
      >
        <AppButton
          label={t('form:actions.okay', 'Okay')}
          onPress={onConfirm}
          type="secondaryGray"
          style={{ boxShadow: '0px -11px 10px #171717' }}
        />
      </BaseView>
    </BaseView>
  )
}
